// cart-notification.js
// Muestra un mensaje de "envío gratis a partir de 50€" dentro del cart-drawer,
// cada vez que se abre o se vuelve a renderizar.

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer, .cart-drawer');
  if (!drawer) return;

  const injectFreeShippingMessage = () => {
    const inner = drawer.querySelector('.drawer__inner') || drawer;
    if (!inner) return;

    // Evitar duplicar el mensaje si ya existe
    if (inner.querySelector('.free-shipping-message')) return;

    const msg = document.createElement('div');
    msg.className = 'free-shipping-message';
    msg.style.padding = '12px';
    msg.style.background = '#f3f3f3';
    msg.style.borderRadius = '6px';
    msg.style.marginBottom = '12px';
    msg.style.fontSize = '15px';
    msg.style.lineHeight = '1.4';

    msg.innerHTML = `
      🚚 <strong>¡Aprovecha el envío gratis!</strong><br>
      Para obtener <strong>envío gratuito</strong> tu pedido debe alcanzar los <strong>50€</strong>.
    `;

    // Lo ponemos al principio del contenido del drawer
    inner.prepend(msg);
  };

  // Inyectamos una primera vez por si el drawer ya está renderizado
  injectFreeShippingMessage();

  // Observamos cambios en el drawer, porque Shopify vuelve a escribir su HTML
  // cuando se añade algo al carrito (renderContents())
  const observer = new MutationObserver(() => {
    injectFreeShippingMessage();
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true,
  });
});
